import {
  Button,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import history from 'utils/history'

const NotFound = () => (
  <Container>
    <Container className="py-5">
      <img src="./assets/homepage/img-forbiden-access.svg" alt="penyedia_barang" className="img-not-found m-t-50 m-b-32"/>
      <h3 className="font-bold m-b-16">Halaman Tidak Ditemukan</h3>
      <div className="font-size-20 grey-text">Pastikan alamat yang Anda masukkan sudah benar lalu coba lagi.</div>
    </Container>
    {/* <Row>
      <Col md="12" className="mx-auto text-center">
        <img src="/assets/404.png" className="img-fluid" alt="404" />

        <div className="error-details mt-0">
          Sorry, an error has occured, Requested page not found!
        </div>

        <Button onClick={() => history.goBack()} variant="primary">Go Back</Button>
      </Col>
    </Row> */}
  </Container>
)

export default NotFound
